import React from 'react'

const WineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.66667 12.25V11.0833H6.41667V8.69167C5.58056 8.55556 4.88542 8.16667 4.33125 7.525C3.77708 6.88333 3.5 6.125 3.5 5.25V1.75H10.5V5.25C10.5 6.125 10.2229 6.88333 9.66875 7.525C9.11458 8.16667 8.41944 8.55556 7.58333 8.69167V11.0833H9.33333V12.25H4.66667ZM4.66667 4.66667H9.33333V2.91667H4.66667V4.66667Z'
      fill='currentColor'
    />
  </svg>
)

export default WineIcon
